import { loadStripe, Stripe, StripeElementLocale } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { STRIPE_PK, DEFAULT_LOCALE } from 'src/utils/constants';

export default function useStripePromise() {
  const [stripePromise, setStripePromise] = useState<null | Promise<Stripe | null>>(null);

  useEffect(() => {
    if (!stripePromise && STRIPE_PK) {
      setStripePromise(loadStripe(STRIPE_PK, { locale: DEFAULT_LOCALE as StripeElementLocale }));
    }
  }, [stripePromise]);

  return stripePromise;
}
